"use strict";

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.index-of");

require("antd/lib/typography/style");

var _typography = _interopRequireDefault(require("antd/lib/typography"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.find-index.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.object.assign.js");

var _react = _interopRequireWildcard(require("react"));

var _usePreviousValue = _interopRequireDefault(require("../../hooks/usePreviousValue"));

var _WizardForm = _interopRequireDefault(require("../WizardForm"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var _default = WizardFormConfiguration;
exports.default = _default;

function WizardFormConfiguration(_a) {
  var form = _a.form,
      initialValues = _a.initialValues,
      defaultActiveStep = _a.defaultActiveStep,
      onValuesChange = _a.onValuesChange,
      onCancel = _a.onCancel,
      onTouchedChange = _a.onTouchedChange,
      onStepErrorInsist = _a.onStepErrorInsist,
      steps = _a.steps,
      availableSteps = _a.availableSteps,
      loading = _a.loading,
      nextButtonLoading = _a.nextButtonLoading,
      onSubmit = _a.onSubmit,
      saveMode = _a.saveMode,
      rest = __rest(_a, ["form", "initialValues", "defaultActiveStep", "onValuesChange", "onCancel", "onTouchedChange", "onStepErrorInsist", "steps", "availableSteps", "loading", "nextButtonLoading", "onSubmit", "saveMode"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      touched = _useState2[0],
      setTouched = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      showRequired = _useState4[0],
      setShowRequired = _useState4[1];

  var prevTouched = (0, _usePreviousValue.default)(touched);

  var handleCancel = function handleCancel() {
    if (onCancel) {
      onCancel();
    }
  };

  var handleValuesChange = function handleValuesChange(values) {
    onValuesChange && onValuesChange(values);
    var tou = form.isFieldsTouched([], true);

    if (prevTouched !== tou) {
      if (onTouchedChange) {
        setTouched(tou);
        onTouchedChange(tou);
      }
    }
  };

  var handleStepErrorInsist = function handleStepErrorInsist(err) {
    if (onStepErrorInsist) {
      onStepErrorInsist(err);
    }
  };

  var handleStepChange = function handleStepChange(index) {
    setRequired(index);
  };

  (0, _react.useEffect)(function () {
    var index = defaultActiveStep && steps && steps.findIndex(function (step) {
      return step.key === defaultActiveStep;
    }) || 0;
    setRequired(index);
  }, [steps, defaultActiveStep]);
  var wizardSteps = (0, _react.useMemo)(function () {
    return availableSteps ? steps.filter(function (step) {
      return step.key && availableSteps.includes(step.key);
    }) : steps;
  }, [steps, availableSteps]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "WizardFormConfiguration"
  }, /*#__PURE__*/_react.default.createElement(_WizardForm.default, Object.assign({
    animated: false,
    autoFocusFirstInput: true,
    activeKey: defaultActiveStep,
    form: form,
    formProps: {
      layout: 'vertical',
      initialValues: initialValues,
      onValuesChange: handleValuesChange
    },
    stepsProps: {
      direction: 'vertical'
    },
    headerSize: 200,
    clickableSteps: true,
    bodyStyle: {
      minHeight: 400
    },
    onSubmit: onSubmit,
    cancelButtonText: "Back",
    onCancel: handleCancel,
    enableCancel: true,
    loading: loading,
    nextButtonLoading: nextButtonLoading,
    onStepChange: handleStepChange,
    onStepErrorInsist: handleStepErrorInsist,
    footerExtra: showRequired ? /*#__PURE__*/_react.default.createElement("small", null, /*#__PURE__*/_react.default.createElement(_typography.default.Text, {
      type: "danger"
    }, "*"), ' ', "Required") : null,
    dividerStyle: {
      width: 'calc(100% + 40px)',
      marginLeft: '-20px'
    },
    saveMode: saveMode,
    showCancelButton: !saveMode
  }, rest), wizardSteps));

  function setRequired(index) {
    setShowRequired(!!steps && steps[index] && steps[index].props && steps[index].props.hasRequiredFields);
  }
}

WizardFormConfiguration.Step = function (_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  return /*#__PURE__*/_react.default.createElement(_WizardForm.default.Step, rest, children);
};